import i18n from 'i18next'
import { z } from 'zod'

import type { FieldErrorsMapper } from '@/hooks/useMutationWithErrorsHandling'
import { requiredStringWithLabel } from '@/utils/zod'

export const schoolBreakPayload = z.object({
  name: requiredStringWithLabel(i18n.t('label.name', { ns: 'schoolSettings' })),
  dates: z
    .object({
      from: z.date().optional(),
      to: z.date().optional()
    })
    .refine(data => data.from && data.to, {
      message: i18n.t('error.break-duration-required', {
        ns: 'schoolSettings'
      })
    })
})

export type SchoolBreakFormPayload = z.infer<typeof schoolBreakPayload>

export type SchoolBreakEditFormPayload = SchoolBreakFormPayload & { id: string }

export const schoolBreakFieldErrorsMapper: FieldErrorsMapper<SchoolBreakFormPayload> =
  {
    name: 'name',
    start_date: 'dates',
    end_date: 'dates',
    // the only possible error that occurs is overlapping breaks,
    // which is why we want to show them in the range picker
    non_field_errors: 'dates'
  }
